<template>
  <div class="tc-model-list">
    <r-title type="subtitle-1" style="margin-bottom: 16px;">
      Выберите модель
    </r-title>
    <div class="tc-model-list-content" v-loading="loading">
      <div class="tc-model-list-search">
        <el-input
          prefix-icon="el-icon-search"
          class="r-input"
          v-model="filter"
          placeholder="Поиск по названию модели"
        />
      </div>
      <ul class="tc-model-list-list" v-if="filteredModels.length">
        <li
          class="tc-model-list-item"
          v-for="item in filteredModels"
          :key="item.id"
          @click="changeModel(item)"
        >
          <div class="tc-model-list-item-icon">
            <r-icon name="model" :size="18" />
          </div>
          <div class="tc-model-list-item-info">
            <r-text>{{ item.name }}</r-text>
            <r-text type="caption">
              {{ item.children.length }} внутр. ИД
            </r-text>
          </div>
        </li>
      </ul>
      <div class="tc-model-list-nodata" v-else>
        <r-text type="caption">
          Нет доступных моделей
        </r-text>
      </div>
    </div>
  </div>
</template>

<script>
import { getDatasourcesByDatatype } from "@/utils";

export default {
  data() {
    return {
      models: [],
      model: "",
      filter: "",
      loading: false
    };
  },
  computed: {
    filteredModels() {
      return this.models.filter(
        m => m.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1
      );
    }
  },
  methods: {
    changeModel(model) {
      this.$emit("change-model", model);
    }
  },
  async created() {
    try {
      this.loading = true;
      const where = {
        field: "datatype",
        op: "=",
        value: "model",
        type: "AND"
      };
      const include = { children: {} };
      const models = await getDatasourcesByDatatype(this, where, include);

      this.models = models.filter(
        ds =>
          ds.children.filter(
            l =>
              l.datatype === "count_points" ||
              l.datatype === "general_count_points"
          ).length
      );
      this.loading = false;
    } catch (error) {
      console.log(error);
      this.loading = true;
    }
  }
};
</script>

<style lang="scss">
.tc-model-list {
  &-header {
    margin-bottom: 16px;
  }

  &-content {
    min-height: 64px;
  }

  &-search {
    margin-bottom: 8px;
  }

  &-list {
    max-height: 35vh;
    overflow: auto;
    background-color: var(--modal_bg) !important;
    border-radius: var(--border-radius);
    padding: 8px 0;
  }

  &-item {
    cursor: pointer;
    border-radius: var(--border-radius);
    display: flex;
    padding: 2px 16px;

    &:not(:last-child) {
      margin-bottom: 8px;
    }

    &-icon {
      margin-right: 12px;
    }

    &:hover {
      background-color: rgba(var(--accent_primary), 0.2);
    }

    &:active {
      background-color: rgba(var(--accent_primary), 0.3);
    }
  }

  &-nodata {
    padding: 16px;
    text-align: center;
  }
}
</style>
